/**
 * Get the Events list from API
 * @param {object} state - The vuex state object
 * @return {object[]} A array of events list
 */
export const getEventsList = (state) => {
  return Array.isArray(state.eventList) ? state.eventList : null
};
